import React, { useState } from "react";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbw_vAq_G6dGlK6nbvjdLnF5biGJPnyyCRzi_gig3LsrbsrU1OqlYa_iGBN2XZR00Q0/exec", // Your Google Apps Script Web App URL
        {
          method: "POST",
          mode: "no-cors", // prevents CORS errors
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      setStatus("Thank you! Your message has been sent.");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error(error);
      setStatus("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <section className="contact-page" id="contact">
        <h2>Contact Us</h2>

        <div className="contact-container">
          {/* Contact Form */}
          <div className="contact-form">
            <h3>Send Us A Message</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <textarea
                name="message"
                placeholder="Your Message"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>

              <button type="submit" disabled={loading}>
                {loading ? "Sending..." : "Send Message"}
              </button>

              {status && <p className="form-status">{status}</p>}
            </form>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <div className="info-box">
              <h4>Address</h4>
              <p>
                107 Haymeadow Street, Boardwalk <br />
                Office Park, Pretoria, 0400
              </p>
            </div>

            <div className="info-box">
              <h4>Phone & Email</h4>
              <p>
                <PhoneIcon /> (+27) 72 514 5964
              </p>
              <p>
                <EmailIcon /> admin@mapesa.co.za
              </p>
            </div>
          </div>
        </div>

        {/* Google Maps */}
        <div className="map-section">
              <iframe
          title="Our Office Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3576.---!2d28.---!3d-25.---!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9584---!2s107%20Haymeadow%20Street%2C%20Boardwalk%20Office%20Park%2C%20Pretoria!5e0!3m2!1sen!2sza!4v…"
          width="100%"
          height="350"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>

        </div>
      </section>
    </div>
  );
};

export default ContactUs;
